"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
ShopController.$inject = ['$scope', 'api', 'category', 'breadcrumbs', 'products', 'manufacturers', 'filters', '_categories', '_shop'];
function ShopController($scope, api, category, breadcrumbs, products, manufacturers, filters, _categories, _shop) {
    $scope.categories_list = !category || category.child_count > 0;
    $scope.filters = filters;
    $scope.category = category;
    $scope.breadcrumbs = breadcrumbs;
    $scope.products = products.items;
    $scope.all_products = products.items;
    $scope.manufacturers = manufacturers.items;
    $scope.cart_visible = false;
    $scope.activeFilters = [];
    $scope.sort = '';
    $scope.selected = {};
    // $scope.active_filters = false;
    // $scope.$watch('selected', function(val) {
    //     if (selected.length > 0) {
    //         $scope.active_filters = true;
    //     } else {
    //         $scope.active_filters = false;
    //     }
    // });
    $scope.$on('remove_from_cart', function (event, data) {
        var item = lodash_1.default.find($scope.products, { _id: data._id });
        if (item) {
            item.quantity = 0;
        }
    });
    $scope.$on('change_quantity_from_cart', function (event, data) {
        var item = lodash_1.default.find($scope.products, { _id: data._id });
        if (item) {
            item.quantity = data.quantity;
        }
    });
    $scope.filterChange = function (value, filter) {
        var filter_id = filter == null ? 0 : filter._id;
        var filter_name = filter == null ? 'Proizvodjač' : filter.name;
        var value_id = filter == null ? value.manufacturer_id : value.value_id;
        var value_name = filter == null ? value.name : value.value;
        var active = lodash_1.default.find($scope.activeFilters, { _id: filter_id });
        if (!active) {
            $scope.activeFilters.push({ name: filter_name, _id: filter_id, values: [] });
        }
        var filter_found = lodash_1.default.find($scope.activeFilters, ['_id', filter_id]);
        var value_exists = false;
        if (filter_found.values.length > 0) {
            lodash_1.default.each(filter_found.values, function (child, index) {
                if (child._id == value_id) {
                    value_exists = true;
                }
            });
        }
        if (!value_exists) {
            var f = lodash_1.default.find($scope.activeFilters, ['_id', filter_id]);
            f.values.push({ name: value_name, _id: value_id });
        }
        else {
            var f = lodash_1.default.find($scope.activeFilters, ['_id', filter_id]);
            lodash_1.default.remove(f.values, { _id: value_id });
            $scope.selected[filter_id][value_id] = false;
            if (f.values.length == 0) {
                lodash_1.default.remove($scope.activeFilters, { _id: filter_id });
            }
        }
        filterProducts();
    };
    $scope.removeFilter = function (value, filter) {
        if (filter.name == 'Proizvodjac') {
            //manufacturer
            var param1 = { manufacturer_id: value._id, name: value.name };
            var param2 = null;
        }
        else {
            var param1 = { value_id: value._id, value: value.name };
            var param2 = { _id: filter._id, name: filter.name };
        }
        $scope.filterChange(param1, param2);
    };
    function filterProducts() {
        if (!$scope.activeFilters || !$scope.activeFilters.length) {
            $scope.products = $scope.all_products;
            $scope.$broadcast('productsFiltered');
            return;
        }
        $scope.products = $scope.all_products.filter(function (product) {
            var productFilters = parseProductFilters(product.filter);
            return $scope.activeFilters.every(function (filter) {
                if (filter._id === 0) {
                    return filter.values.some(function (value) {
                        return product.manufacturer_id == value._id;
                    });
                }
                var filterId = filter._id.toString();
                return filter.values.some(function (value) {
                    var valueId = value._id.toString();
                    return productFilters[filterId] === valueId;
                });
            });
        });
        $scope.$broadcast('productsFiltered');
    }
    ;
    function parseProductFilters(filterString) {
        var result = {};
        if (!filterString)
            return result;
        var regex = /data-f(\d+)="(\d+)"/g;
        var match;
        while ((match = regex.exec(filterString)) !== null) {
            var filterId = match[1];
            var valueId = match[2];
            result[filterId] = valueId;
        }
        return result;
    }
    $scope.removeAllFilters = function () {
        $scope.activeFilters = [];
        lodash_1.default.each($scope.filters, function (child, index) {
            lodash_1.default.each(child.values, function (item, index) {
                item.selected = 0;
            });
        });
        $scope.selected = {};
        $scope.products = $scope.all_products;
        $scope.remove = false;
        $scope.$broadcast('productsFiltered');
    };
    $scope.remove = false;
    $scope.$watch('remove', function (val) {
        if (val == true) {
            $scope.removeAllFilters();
        }
    });
    $scope.removeSingle = {};
    $scope.$watch('removeSingle', function (val) {
        if (val && val.value && val.filter) {
            $scope.removeFilter(val.value, val.filter);
            $scope.removeSingle = {};
        }
    });
    //repsonsive
    $scope.showFilters = false;
    $scope.$watch('showFilters', function (val) {
        $scope.showFilters = val;
    });
    $scope.sortArray = _shop.getSortTypes();
    $scope.sortItems = {};
    $scope.sortProducts = function (item) {
        $scope.sortItems = item;
        lodash_1.default.each($scope.sortArray, function (child, index) {
            child.active = 0;
        });
        item.active = 1;
    };
}
exports.ShopController = ShopController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/controllers/ShopController.js
// module id = 354
// module chunks = 0